<app-page headline="Downloads">
  <div
    grid-layout
    gap="lg"
    templateColumns="repeat( auto-fit, minmax(250px, 1fr) )"
  >
    <div
      stack-layout
      borderRadius="xs"
      elevation="raised"
      alignItems="center"
      padding="md"
      color="primary-surface"
    >
      <Text role="headline-small"> Buyer Data (xlsx) </Text>
      <div center-layout padding="md">
        <app-download-button
          mode="text"
          [blobObservable]="buyerService.downloadBuyers()"
          tooltipPlacement="left"
          label="Download"
          [downloadFileName]="buyerDownloadFileName()"
        />
      </div>
    </div>
    <div
      stack-layout
      borderRadius="xs"
      elevation="raised"
      alignItems="center"
      padding="md"
      color="primary-surface"
    >
      <Text role="headline-small"> Shipping Rates (xlsx) </Text>
      <div center-layout padding="md">
        <app-download-button
          mode="text"
          [blobObservable]="ecommerceService.downloadShippingRates()"
          tooltipPlacement="left"
          label="Download"
          [downloadFileName]="shippingRatesDownloadFileName()"
        />
      </div>
    </div>
    <div
      stack-layout
      borderRadius="xs"
      elevation="raised"
      alignItems="center"
      padding="md"
      color="primary-surface"
    >
      <Text role="headline-small"> Tax Rates (xlsx) </Text>
      <div center-layout padding="md">
        <app-download-button
          mode="text"
          [blobObservable]="ecommerceService.downloadTaxRates()"
          tooltipPlacement="left"
          label="Download"
          [downloadFileName]="taxRatesFileName()"
        />
      </div>
    </div>
    <div
      stack-layout
      borderRadius="xs"
      elevation="raised"
      alignItems="center"
      padding="md"
      color="primary-surface"
    >
      <Text role="headline-small"> LINC Login Report (xlsx) </Text>
      <div center-layout padding="md">
        <app-download-button
          mode="text"
          [blobObservable]="lincLoginReportService.downloadLoginReport()"
          tooltipPlacement="left"
          label="Download"
          [downloadFileName]="lincLoginReportFileName()"
        />
      </div>
    </div>
    <div
      stack-layout
      borderRadius="xs"
      elevation="raised"
      alignItems="center"
      padding="md"
      color="primary-surface"
    >
      <Text role="headline-small"> Currency Conversion (xlsx) </Text>
      <div center-layout padding="md">
        <app-download-button
          mode="text"
          label="Download"
          [routerLink]="['/currency-conversion']"
        />
      </div>
    </div>
  </div>
</app-page>
